import { ADMIN_SET_UI } from '../../constants/admin/adminActions'
import { AdminUI } from '../../constants/admin/adminUi'

export const setAdminUIAction = (state: AdminUI) => ({ type: ADMIN_SET_UI, payload: state })
